import { DATE_FORMAT_DAY_MONTH_YEAR } from '@constants/datetime';
import { formatDateTime } from '@utils/date-time-format/format-date-time';
import { fromBackend } from '@utils/map-date/from-backend';

export const headerDateFormat = (date: number, lang: string, timezone: string) => {
  return formatDateTime({
    date: fromBackend(date, timezone).toDate(),
    locale: lang,
    format: DATE_FORMAT_DAY_MONTH_YEAR,
    timezone,
  });
};
